import { PapiDeviation } from '@wix/da-papi-types';
import { SellableAs } from './types';

/**
 * Returns a list of all valid sell options for a deviation.
 *
 * Relies on extended deviation data being loaded.
 */
export function getSellableAs(item: PapiDeviation): SellableAs[] {
  return (item.extended?.sellableAs as SellableAs[] | undefined) ?? [];
}

export function getIsStash(item: PapiDeviation) {
  return !!item.stashPrivateid;
}

export function getDreamupPrompt(item: PapiDeviation): string | undefined {
  return item.extended?.dreamsofart?.prompt;
}

/**
 * Returns `true` if the supplied deviation is an adoptable that has been traded.
 *
 * NOTE: This function isn't accurate if an adoptable has been sold, then re-bought by the original author. Product has
 * accepted us ignoring this edge case.
 */
export function getHasBeenTraded(item: PapiDeviation) {
  return item.adoptable?.owner && item.author && item.adoptable.owner.userId !== item.author.userId;
}
